export * from 'server/models/Image';


// WEBPACK FOOTER //
// ./data/models/Image.ts